"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllChainsBalances = exports.encodeJuneoAddress = exports.recoverAddress = exports.validatePrivateKey = exports.trackJuneoTransaction = exports.getImportUserInputs = exports.sortSpendings = exports.JVMPrivateKeyPrefix = void 0;
const chain_1 = require("../chain");
const transaction_1 = require("../transaction");
const wallet_1 = require("../wallet");
const crypto_1 = require("./crypto");
const encoding_1 = require("./encoding");
exports.JVMPrivateKeyPrefix = 'PrivateKey-';
const PrivateKeyLength = 64;
function sortSpendings(spendings) {
    const values = new Map();
    for (const spending of spendings) {
        const key = `${spending.chain.id}_${spending.assetId}`;
        if (!values.has(key)) {
            values.set(key, new wallet_1.BaseSpending(spending.chain, spending.amount, spending.assetId));
        }
        else {
            values.get(key).amount += spending.amount;
        }
    }
    return values;
}
exports.sortSpendings = sortSpendings;
function getImportUserInputs(values, feeAssetId, feeAmount, source, destination, address) {
    const inputs = [];
    for (const [key, value] of values) {
        const amount = key === feeAssetId ? value - feeAmount : value;
        if (amount > BigInt(0)) {
            inputs.push(new transaction_1.UserInput(key, source, amount, [address], 1, destination));
        }
    }
    return inputs;
}
exports.getImportUserInputs = getImportUserInputs;
async function trackJuneoTransaction(chain, executable, transactionId, transactionType) {
    let success = false;
    const vmId = chain.vm.id;
    if (vmId === chain_1.JVM_ID) {
        success = await executable.trackJVMTransaction(transactionId, transactionType);
    }
    else if (vmId === chain_1.PLATFORMVM_ID) {
        success = await executable.trackPlatformTransaction(transactionId, transactionType);
    }
    else if (vmId === chain_1.JEVM_ID) {
        success = await executable.trackJEVMTransaction(chain.id, transactionId, transactionType);
    }
    return success;
}
exports.trackJuneoTransaction = trackJuneoTransaction;
function validatePrivateKey(data) {
    if ((0, encoding_1.isHex)(data)) {
        const hasPrefix = (0, encoding_1.hasHexPrefix)(data);
        const length = hasPrefix ? data.substring(2).length : data.length;
        return length === PrivateKeyLength;
    }
    if (data.includes(exports.JVMPrivateKeyPrefix)) {
        const split = data.split('-');
        const base58 = split.length > 1 && (0, encoding_1.isBase58)(split[1]);
        return base58 && (0, encoding_1.decodeCB58)(split[1]).length === PrivateKeyLength / 2;
    }
    return false;
}
exports.validatePrivateKey = validatePrivateKey;
function recoverAddress(signature, message) {
    return new transaction_1.Address(publicKeyToAddress((0, crypto_1.recoverPubKey)(signature, message)));
}
exports.recoverAddress = recoverAddress;
function publicKeyToAddress(publicKey) {
    return (0, crypto_1.rmd160)((0, crypto_1.sha256)(publicKey));
}
function encodeJuneoAddress(publicKey, hrp) {
    return (0, encoding_1.encodeBech32)(hrp, publicKeyToAddress(publicKey));
}
exports.encodeJuneoAddress = encodeJuneoAddress;
/**
 * Fetch the balances of all the registered assets of the chains of the accounts.
 */
async function fetchAllChainsBalances(account) {
    const promises = [];
    for (const chainAccount of account.chainAccounts.values()) {
        promises.push(chainAccount.fetchBalances(chainAccount.chain.getRegisteredAssets()));
    }
    await Promise.all(promises);
}
exports.fetchAllChainsBalances = fetchAllChainsBalances;
